import script from "./GaleriaFotosAcao.vue?vue&type=script&setup=true&lang=js"
export * from "./GaleriaFotosAcao.vue?vue&type=script&setup=true&lang=js"

import "./GaleriaFotosAcao.vue?vue&type=style&index=0&id=7b6f26bf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b6f26bf"]])

export default __exports__